module.exports = __webpack_public_path__ + "images/technology.jpg?8037bd7";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/technology.jpg
// module id = 342
// module chunks = 0